<template>
    <card>
        <template #content>
            <div class="p-inputtext-sm p-fluid">
                <div class="grid">
                    <div class="col-12">
                        <DataTable
                            :loading="!workOrderModels"
                            :value="workOrderModels"
                            responsiveLayout="scroll"
                            class="p-datatable-sm editable-cells-table"
                            :showGridlines="true"
                            :scrollable="true"
                            scrollHeight="300px"
                        >
                                <Column field="Type" :header="$t('wo_type')" >
                                    <template #body="slotProps">
                                        <InputText
                                        v-model="slotProps.data.Type"
                                        :disabled="true"
                                         style="background-color: white; color: black; opacity: 1;"
                                        />
                                    </template>
                                </Column>
                                <Column field="No_Wo" :header="$t('wo_No')" >
                                    <template #body="slotProps">
                                        <InputText
                                        v-model="slotProps.data.No_Wo"
                                        :disabled="true"
                                         style="background-color: white; color: black; opacity: 1;"
                                        />
                                    </template>
                                </Column>
                                <Column field="Status" :header="$t('wo_status')" >
                                    <template #body="slotProps">
                                        <InputText
                                        v-model="slotProps.data.Status"
                                        :disabled="true"
                                        style="background-color: white; color: black; opacity: 1;"
                                        />
                                    </template>
                                </Column>
                                <Column field="Link_MC" :header="$t('link_mc')" >
                                    <template #body="slotProps">
                                        <InputText
                                        v-model="slotProps.data.Link_MC"
                                        :disabled="true"
                                         style="background-color: white; color: black; opacity: 1;"
                                        />
                                    </template>
                                </Column>
                                <Column field="Tendering_Completed" :header="$t('Is_Tendering_Completed')" >
                                    <template #body="slotProps">
                                        <InputText
                                        v-model="slotProps.data.Tendering_Completed"
                                        :disabled="true"
                                         style="background-color: white; color: black; opacity: 1;"
                                        />
                                    </template>
                                </Column>
                                <Column field="New_SPO" :header="$t('New_SPO')" >
                                    <template #body="slotProps">
                                        <InputText
                                        v-model="slotProps.data.New_SPO"
                                        :disabled="true"
                                         style="background-color: white; color: black; opacity: 1;"
                                        />
                                    </template>
                                </Column>
                                <Column field="SPO_No" :header="$t('SPO_No')" >
                                    <template #body="slotProps">
                                        <InputText
                                        v-model="slotProps.data.SPO_No"
                                        :disabled="true"
                                         style="background-color: white; color: black; opacity: 1;"
                                        />
                                    </template>
                                </Column>
                                <Column field="SPO_Item" :header="$t('SPO_Item')" >
                                    <template #body="slotProps">
                                        <InputText
                                        v-model="slotProps.data.SPO_Item"
                                        :disabled="true"
                                         style="background-color: white; color: black; opacity: 1;"
                                        />
                                    </template>
                                </Column>
                                <Column field="Contract_Amount" :header="$t('Nilai_Kontrak')" >
                                    <template #body="slotProps">
                                        <InputNumber
                                        v-model="slotProps.data.Contract_Amount"
                                        :useGrouping="true" :maxFractionDigits="2" :minFractionDigits="2"
                                        :disabled="true"
                                        :inputStyle="{ backgroundColor: 'white', color: 'black', opacity: 1 }"
                                        />
                                    </template>
                                </Column>
                        </DataTable>
                    </div>
                </div>
            </div>
        </template>
    </card>
</template>
<script>
export default 
{
    props: {
        header:{
            type:Object,
            default:null
        }
    },
    data() {
        return {
        }
    },
    computed: {
        workOrderModels() 
        {
            const wo = this.header ? this.header.WorkOrderModels : null;
            return wo;
        }
    },
}
</script>

